import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'libs/ui';
import { Input } from './input';
import { Select } from './select';
import { Label } from './label';
import { Control } from './control.styled';

export const BarcodeControl = (props) => {
  const { onChange } = props;
  const [n1, setN1] = useState(2);
  const [n2, setN2] = useState(250);
  const [pos, setPos] = useState('ABOVE');
  const { t } = useTranslation();

  const insert = () => {
    const code = '%barcode%,' + n1 + ',' + n2 + ',' + pos;
    onChange(code);
  };

  return (
    <Control>
      <Label>{t('forms.ШК')}:</Label>
      <Select name="n1" value={n1} onChange={setN1}>
        <option value="1">1</option>
        <option value="2">2</option>
      </Select>
      <Input name="n2" placeholder="250" value={n2} onChange={setN2} width={'4.6ch'} asNumber />
      <Select name="pos" value={pos} onChange={setPos}>
        <option value="OFF">OFF</option>
        <option value="ABOVE">ABOVE</option>
        <option value="BELOW">BELOW</option>
      </Select>
      <Button size="small" $square onClick={insert}>
        &raquo;
      </Button>
    </Control>
  );
};
